import { useContext } from 'react';
import { UseQueryResult, useQuery } from 'react-query';
import { DEFAULT_ERROR_MESSAGE } from '../../Base.constants';
import { SessionContext } from '../../context/SessionContext';
import { ToastContext } from '../../context/ToastContext';
import { Session, getSessions } from '../../services/chat/getSessions.service';
import { queryKeys } from '../queryKeyFactory';

export const useGetSessions = (): UseQueryResult<Session[], Error> => {
  const { isLoading, acceptedTerms, sessionInfo } = useContext(SessionContext);
  const { sessionId } = sessionInfo;
  const toast = useContext(ToastContext);

  return useQuery([queryKeys.chat.getSessions], getSessions, {
    onError: () => {
      toast.error(DEFAULT_ERROR_MESSAGE);
    },
    enabled: !isLoading && !!sessionId && acceptedTerms,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
